"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCommission = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _moment = _interopRequireDefault(require("@package/moment"));

var _request = _interopRequireDefault(require("@package/request"));

var _logger = require("@package/logger");

var _errors = require("@package/errors");

var notifications = _interopRequireWildcard(require("@package/notifications"));

var _slice = require("../slice");

var getCommission = function getCommission(formData) {
  var isDebit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(dispatch) {
      var date, additionalParams, result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Запрос на расчет комиссии'
              });
              dispatch((0, _slice.getCommissionRequestAction)());
              date = (0, _moment["default"])().format('YYYY-MM-DD HH:mm:ss.SSSSSS+03:00');
              additionalParams = {};

              if (isDebit) {
                additionalParams['amountDebit'] = formData['amount-debit'] || 0;
              } else {
                additionalParams['amountCredit'] = formData['amount-credit'] || 0;
              }

              if (formData['method'] && formData['method']['name'] === 'BankCard' && formData['destination']) {
                additionalParams['pan'] = formData['destination'].slice(0, 6);
              }

              _context.next = 9;
              return (0, _request["default"])({
                url: '/billing/calculations/commissions',
                method: 'get',
                params: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
                  date: date,
                  TYPE: 'PAYOUT'
                }, additionalParams), {}, {
                  shopId: formData['shop']['id'],
                  currency: formData['account']['name'],
                  paymentMethodId: formData['method']['id']
                })
              });

            case 9:
              result = _context.sent;
              dispatch((0, _slice.getCommissionRequestSuccessAction)(result['data']));
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Коммисия успешно расчитана'
              });
              return _context.abrupt("return", result['data']);

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](0);

              if (!(_context.t0 instanceof _errors.UnauthorizedError)) {
                _context.next = 19;
                break;
              }

              return _context.abrupt("return", void 0);

            case 19:
              dispatch((0, _slice.getCommissionRequestFailAction)(_context.t0['data']));

              if (!/^74\.7\w/.test(_context.t0['data']['code'])) {
                dispatch(notifications.pushFail(_context.t0['data']));
              }

              (0, _logger.push)({
                owner: 'Navigate',
                level: 'error',
                message: 'Ошибка при запросе на расчет комиссии'
              });

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 15]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getCommission = getCommission;